<template>
    <div class="message-item" v-show="!options.isRevoked">
        <BaseCustomMessage v-if="options.type === 'TIMCustomElem' && payloadData.customType !== 'sys' && payloadData.customType !== 'image' && JSON.parse(options.payload.data).customType !== 'video_call'" :options="options" :serviceType="serviceType"></BaseCustomMessage>
        <div class="me message-body" v-if="options.from === (orderDetail.patientIMID || orderDetail.orderPatientID || imInfo.patientImID) &&
            (options.type !== 'TIMCustomElem' || (payloadData && payloadData.customType === 'image'))
            ">
            <div class="me-image portrait" :class="deviceType == 'alipay' ? 'color-bg-huafu' : ''">
                <!-- <img src="../../assets/image/avatarPatient.png" /> -->
                {{ patientName.substr(0, 1) }}
            </div>
            <div class="me-message bubble">
                <BaseTextMessage v-if="options.type === 'TIMTextElem'" :options="options"></BaseTextMessage>
                <BaseImageMessage
                    v-if="options.type === 'TIMImageElem' || (payloadData && payloadData.customType === 'image')"
                    :options="options"></BaseImageMessage>
                <BaseVideoMessage v-if="options.type === 'TIMVideoFileElem'" :options="options"></BaseVideoMessage>
            </div>
        </div>

        <div class="other message-body" v-else-if="options.from !== (orderDetail.patientIMID || orderDetail.orderPatientID || imInfo.patientImID) &&
            (options.type !== 'TIMCustomElem' || (payloadData && payloadData.customType === 'image'))
            ">
            <div class="other-image portrait">
                <img :src="doctorInfo.faceImage" v-if="doctorInfo.faceImage" />
                <img src="../../assets/image/avatarDoctor.png" v-else />
            </div>
            <div class="other-message bubble">
                <BaseTextMessage v-if="options.type === 'TIMTextElem'" :options="options"></BaseTextMessage>
                <BaseImageMessage
                    v-if="options.type === 'TIMImageElem' || (payloadData && payloadData.customType === 'image')"
                    :options="options"></BaseImageMessage>
                <BaseVideoMessage v-if="options.type === 'TIMVideoFileElem'" :options="options"></BaseVideoMessage>
            </div>
        </div>

        <div class="other message-body" v-else-if="options.from !== (orderDetail.patientIMID || orderDetail.orderPatientID) &&
            options.type == 'TIMCustomElem' &&
            JSON.parse(options.payload.data).customType == 'video_call'
            ">
            <div class="other-image portrait">
                <img :src="doctorInfo.faceImage" v-if="doctorInfo.faceImage" />
                <img src="../../assets/image/avatarDoctor.png" v-else />
            </div>
            <div class="other-message bubble">
                <BaseTextMessage :options="options"></BaseTextMessage>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseImageMessage from './components/BaseImageMessage.vue'
import BaseTextMessage from './components/BaseTextMessage.vue'
import BaseVideoMessage from './components/BaseVideoMessage.vue'
import BaseCustomMessage from './components/BaseCustomMessage.vue'
export default {
    name: 'baseMessageItem',
    components: {
        BaseImageMessage,
        BaseTextMessage,
        BaseVideoMessage,
        BaseCustomMessage,
    },
    data() {
        return {}
    },
    computed: {
        payloadData: function () {
            if (typeof this.options.payload.data === 'string' && this.options.type === 'TIMCustomElem') {
                console.log('json--', JSON.parse(this.options.payload.data).data)
                return JSON.parse(this.options.payload.data)
            } else {
                console.log('json==', this.options.payload.data)
                return this.options.payload.data
            }
        },
        patientName: function () {
            return this.userInfo.patientInfo.patientName
        },
        ...mapGetters(['orderDetail', 'doctorInfo', 'userInfo', 'imInfo', "deviceType"]),
    },
    props: {
        options: {
            type: Object,
            default: () => { },
        },
        serviceType: {
            type: Number,
            default: 1,
        }
    },
    mounted() { },
}
</script>

<style lang="scss" scoped>
@import '../../styles/common.scss';
.message-item {
    width: 100%;
    margin-bottom: 12px;
}

.message-item-container {
    background-color: #ebeef5;
    border-radius: 8px;
    padding: 4px 10px;
    word-break: break-all;
    font-size: 14px;
    display: inline-block;
}

.message-item-container>video {
    width: calc(80vw - 57px);
}

.message-body {
    display: flex;
    width: 80%;
}

.bubble {
    flex: 1;
}

.me {
    margin-left: 20%;
    flex-direction: row-reverse;
}

.portrait {
    height: 32px;
    width: 32px;
    margin: 0 16px 0 12px;
    border-radius: 16px;
    /* background: rgb(211, 235, 254); */
}

.portrait>img {
    height: 32px;
    width: 32px;
    border-radius: 16px;
}

.bubble>img {
    height: 100px;
    width: 100px;
}

.bubble>video {
    height: 200px;
    width: 200px;
}

.me-message {
    display: flex;
    flex-direction: row-reverse;
}

.me-image {
    background: var(--order-primary, #{$color});
    color: var(--order-on-primary, white);
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 32px;
}
</style>
